import * as React from 'react';
import * as styles from './GeoDistance.css';

import { INewbuildingGeoDistance } from '../../types/newbuilding';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import { UIText2 } from '@cian/ui-kit';

const getTransportTypeName = (transportType: string) => {
  switch (transportType) {
    case 'transport':
      return 'на транспорте';
    case 'walk':
      return 'пешком';
    default:
      return '';
  }
};

const getGeoName = (type: string) => {
  switch (type) {
    case 'district':
      return 'района';
    case 'street':
      return 'ул.';
    case 'country':
      return 'страны';
    case 'location':
      return 'местоположения';
    case 'road':
      return 'шоссе';
    case 'underground':
      return 'метро';
    case 'house':
      return 'дома';
    default:
      return '';
  }
};

export interface IGeoDistanceProps {
  seoGeoDistance?: INewbuildingGeoDistance | null;
  urlFinisher?: string;
}

export const GeoDistance = ({ seoGeoDistance, urlFinisher }: IGeoDistanceProps) => {
  if (!seoGeoDistance) {
    return null;
  }
  const { travelTime, type, transportType, name } = seoGeoDistance;

  const spot = `${getGeoName(type)} ${name}`;

  return (
    <div className={styles['container']} data-testid="ExpectedTime">
      <UIText2 display="inline">
        {`${travelTime}${NO_BREAK_SPACE}мин. ${getTransportTypeName(transportType)} от `}
        {urlFinisher ? (
          <a className={styles['link']} target="_blank" href={urlFinisher} rel="noreferrer">
            <UIText2 color="current_color" display="inline">
              {spot}
            </UIText2>
          </a>
        ) : (
          spot
        )}
      </UIText2>
    </div>
  );
};
